import { Link } from 'react-router-dom';
import { GrSchedule } from 'react-icons/gr';
import { Button } from '@chakra-ui/react';
import { useViewer } from '~/hooks';

type GoToScheduleType = {
    isDisabled: boolean;
    state?: { projectId?: number; subprojectId?: number; branchId?: number };
};

export const GoToScheduleButton = ({ isDisabled, state = {} }: GoToScheduleType) => {
    const viewer = useViewer();
    const onlyShowOwnEvents = viewer.hasPermission('additional.onlyShowOwnEvents', 'enabled');
    return (
        <Button
            isDisabled={isDisabled}
            data-test-id="button-to-schedule"
            as={Link}
            state={state}
            to={onlyShowOwnEvents ? '/projekte/termine/person' : '/projekte/termine'}
            variant="outline"
            rightIcon={<GrSchedule />}
        >
            Zum Terminplan
        </Button>
    );
};
